export default "__VITE_ASSET__CpPcPbEK__"